import styled from "styled-components";

export const CreateButtonWrapper = styled.div`
    position: relative;
    width: 99px;
    height: 40px;
`;

export const ActionIconWrapper = styled.div`
    img {
        filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%);
    }
`;

export const CreateButtonOptionWrapper = styled.div`
    top: 40px;
    right: 0;
    margin-top: 4px;
    position: absolute;
    display: ${(props) => (props.visible === "true" ? "flex" : "none")};
    width: 150px;
    flex-direction: column;
    align-items: center;
    border-radius: 8px;
    border: 1px solid ${(props) => props.theme.colors.silverGrayTwo};
    background: ${(props) => props.theme.colors.primaryWhite};
    z-index: 1000;
`;

export const ItemOptionWrapper = styled.div`
    display: flex;
    width: 100%;
    padding: 0 16px;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    height: 30px;
    color: ${(props) => props.theme.colors.greyThirteen};
    ${props => props.theme.fonts.variant.bold()}
    font-size: 10px;
    font-style: normal;
    line-height: normal;
    cursor: pointer;
    &:not(:last-child) {
        border-bottom: 1px solid ${(props) => props.theme.colors.silverGrayTwo};
    }
    &:hover {
        opacity: 0.8;
    }
`;